import axios from 'axios'
import { ReportData } from '../../../pages/Reports/types'

export interface GetSystemReportsUseCase {
  execute(secret: string): Promise<ReportData>
}

export class RemoteGetSystemReports implements GetSystemReportsUseCase {
  constructor(private readonly url: string) {}

  async execute(secret: string): Promise<ReportData> {
    // Use axios directly to avoid authorization headers
    const response = await axios.get(
      `${this.url}/system/comprehensive-report?secret=${encodeURIComponent(
        secret
      )}`
    )
    return response.data
  }
}
